import { MerchantRecommendedExchangeSchema } from "@redotech/redo-agents-common/returns-agents/exchange-agent/merchant-recommended-exchange";
import * as z from "zod";

export const getMerchantRecommendedExchanges = {
  name: "getMerchantRecommendedExchanges" as const,
  input: z.object({}),
  output: z.object({
    enableMerchantRecommendedExchanges: z.boolean(),
    merchantRecommendedExchanges: z.array(MerchantRecommendedExchangeSchema),
  }),
};
